
export const NumberTSFormatFilter = {
  install: function (Vue) {
    // thousand seperator number format
    Vue.filter('tsformat', function (value) {
      return value.toLocaleString()
    })
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/number-format-filter.js